const scheduleTriggerDefaults = {
  triggerTimes: {
    item: [
      {
        mode: 'everyHour',
        minute: 0,
      }
    ]
  },
  timezone: 'UTC'
};

export default scheduleTriggerDefaults;
